module.exports = __webpack_public_path__ + "a195fb3a01a6ed0d078c04a60a535168.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-31.png
// module id = 2331
// module chunks = 0